import { frontendURL } from '../../../../helper/URLHelper';

// La gestión de códigos vive ahora en la pantalla Atribución; la ruta
// antigua se conserva para no romper enlaces guardados.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/marketing_campaigns'),
      name: 'marketing_campaigns_index',
      redirect: to => ({
        name: 'attribution_index',
        params: { accountId: to.params.accountId },
      }),
    },
  ],
};
